import React from "react";
const headerFields = [
  { key: "auditNumber", label: "Assessment Reference Number" },
  { key: "auditTitle", label: "Assessment Title" },
  { key: "dateConducted", label: "Date Conducted", type: "date" },
  { key: "assessor", label: "Assessor Name" },
  { key: "reviewer", label: "Reviewer/Validator" },
  { key: "client", label: "Client/Responsible Person" },
  { key: "siteAddress", label: "Site Address" },
  { key: "PropertyDetails", label: "Property Details" }
];
export default function DocumentHeaderForm({ data, onChange }) {
  return (
    <fieldset className="fra-fieldset">
      <legend>Document Header</legend>
      {headerFields.map(({ key, label, type }) => (
        <div className="fra-form-group" key={key}>
          <input
            type={type || "text"}
            value={data[key] || ""}
            onChange={e => onChange({ ...data, [key]: e.target.value })}
            placeholder={label}
            required
          />
          <label>{label}</label>
        </div>
      ))}
    </fieldset>
  );
}
